export const APP_NAME = 'shopping-context';

/** The poll timeout / interval for checking the shopping bag provider ready promise availability. */
export const BASKET_PROVIDER_POLL_TIMEOUT = 250;
//# sourceMappingURL=constants.js.map